import { useEffect, useState } from "react";

import { useQuery } from "@apollo/client";
import { GET_PAGES } from "schemas/query";

import ReactTable from "ui-component/ReactTable";
import { useAppDispatch } from "store/hooks";
import { snackbarOpen } from "store/slice/snackbarSlice";

const PageList = () => {
  const [pages, setPages] = useState([]);

  const dispatch = useAppDispatch();

  const { loading, data } = useQuery(GET_PAGES, {
    onError: (error) => {
      dispatch(
        snackbarOpen({
          open: true,
          message: error.message,
          severity: "error",
        })
      );
    },
  });

  const columns = [
    {
      Header: "#",
      accessor: "index",
    },
    {
      Header: "Title",
      accessor: "title",
    },
    {
      Header: "Author",
      accessor: "author",
    },
    {
      Header: "Date published",
      accessor: "createdAt",
    },
    {
      Header: "Url",
      accessor: "slug",
    },
    {
      Header: "Actions",
      accessor: "actions",
    },
  ];

  useEffect(() => {
    if (data) {
      setPages(data.getPages);
    }
  }, [data]);

  return (
    <ReactTable
      data={pages}
      pageColumns={columns}
      loading={loading}
    ></ReactTable>
  );
};

export default PageList;
